import React, { useState } from 'react';
import loginLogo from '../images/Logo_Log In.png';
import topLeftLogo from '../images/Logo_Top Left Corner.png';
import { useNavigate } from 'react-router-dom';
import hybridAuthService from '../services/hybridAuthService';
import '../css/LoadingSpinner.css';

// Login component handles user authentication UI and logic
function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Handle login form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Check for empty fields
    if (!email.trim() || !password.trim()) {
      setError('Missing email or password, please try again.');
      setIsLoading(false);
      return;
    }

    try {
      const response = await hybridAuthService.login(email, password);
      if (response.user) {
        onLogin(response.user.email); // Set the user's email in App state
        // Fetch profile to determine class-based default
        try {
          const profile = await hybridAuthService.getProfile();
          const classId = profile?.class_id ?? null;
          if (classId === 'ac800e1b-18a3-4dfd-9839-778e41489323') {
            navigate('/dashboard');
          } else {
            navigate('/reading');
          }
        } catch (e) {
          navigate('/reading');
        }
      } else {
        setError('Wrong email or password, please try again.');
      }
    } catch (error) {
      // Handle specific Supabase error messages
      if (error.message && error.message.includes('missing email or phone')) {
        setError('Missing email or password, please try again.');
      } else {
        setError(error.message || 'Wrong email or password, please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* LEFT SIDE: Branding and Logo Section */}
      <div className="login-left">
        {/* Top left: Small logo and company title (header) */}
        <div className="page-header">
          <img src={topLeftLogo} alt="ReadSphere Logo" className="logo-img small" />
        </div>
        {/* Centered: Large logo and app name */}
        <div className="logo-area">
          <img src={loginLogo} alt="ReadSphere Logo" className="logo-img" />
        </div>
      </div>
      {/* RIGHT SIDE: Login Form Section */}
      <div className="login-right">
        {/* Centered login form area */}
        <div className="login-form-area">
          {/* Welcome message and subtitle (white text) */}
          <h2 className="welcome-title enlarged">Welcome to ReadSphere!</h2>
          <p className="subtitle enlarged">Please log in with your account.</p>
          {/* Login form with email and password fields, each with icons */}
          <form className="login-form" onSubmit={handleSubmit}>
            {/* Email input with icon */}
            <div className="input-wrapper">
              <span className="input-icon">
                <i className="fa-solid fa-envelope" aria-hidden="true" />
              </span>
              <input 
                type="email" 
                placeholder="Email" 
                className="input-box enlarged" 
                value={email} 
                onChange={e => setEmail(e.target.value)}
                disabled={isLoading}
              />
            </div>
            {/* Password input with icon */}
            <div className="input-wrapper">
              <span className="input-icon">
                <i className="fa-solid fa-lock" aria-hidden="true" />
              </span>
              <input 
                type="password" 
                placeholder="Password" 
                className="input-box enlarged" 
                value={password} 
                onChange={e => setPassword(e.target.value)}
                disabled={isLoading}
              />
            </div>
            {/* Login button */}
            <button 
              type="submit" 
              className="login-btn enlarged"
              disabled={isLoading}
            >
              {isLoading ? 'Logging in...' : 'Log In'}
            </button>
            {error && <div style={{ color: 'red', marginTop: 10, textAlign: 'center' }}>{error}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
